<template>
  <div style="min-width: 1230px" class="schoolHomeContainer">
    <topLeftNav ref="topLeftNav" :isAppenLi="isAppenLi" :isCollapse="isCollapse" :activeTotalMenu="activeTotalMenu" :leftNavList="leftNavList" :activeTopMenu="activeTopMenu" :styleTemp="bottomNavData" @handleNavClick="handleNavClick" />
    <el-container
      :class="['schoolHome', isShowBottomNavBar == true ? 'pb100' : '']"
      :style="{
        '--pb': bottomNavData.bottomContentInfo && bottomNavData.bottomContentInfo.bottomPos ? bottomNavData.bottomContentInfo.bottomPos.navH + 'px' : '100px',
      }"
      style="flex-direction: column;"
    >
      <el-container>
        <el-header
          :class="{
            'fixed-top': handlePosition,
            'free-nav' : navFree
          }"
          class="header headerBg"
          v-if="isShowTopNavBar"
          :style="{
            height: headerHeight,
            left: navFree ? styleInfo.leftPos + 'px' : '',
            top: navFree ? styleInfo.topPos + 'px' : '',
            width: navFree ? styleInfo.navWidth : '100%',
            position: navFree && styleInfo.slideEffect === 'suspension' ? 'fixed' : ''
          }"
        >
          <header-zun
            :typeShow="1"
            @nav-click="handleMenuClick"
            @change-style-info="styleInfo = $event"
            @changeDeskId="customDeskId = $event"
            @headerInfo="headerInfo"
            @close-login="isOpenLogin = false"
            @changeNav="pageJump"
            @getToken="getToken"
            @close-loading="isLoading = false"
            @collapse="isCollapse = $event"
            :isCollapse="isCollapse"
            :isAppenLi="isAppenLi"
            :isOpenLogin="isOpenLogin"
            v-model:loginStatus="loginStatus"
            v-model:loginMethod="loginMethod"
            :activeTopMenu="activeTopMenu"
            :activeTopChildMenu="activeTopChildMenu"
            ref="headerZun"
          />
        </el-header>
        <el-main class="schoolHome-main">
          <router-view>
            <template v-slot="{ Component  }">
              <component 
                :is="Component"
                ref="schoolMain"
                @on-success="getFooterData"
                @open-login="openLogin"
                @pageJump="openTopNav"
                @change-menu="activeTopMenu = $event"
                @change-cmenu="activeTopChildMenu = $event"
                @change-totalmenu="activeTotalMenu = $event"
                :isCollapse="isCollapse"
                :activeTotalMenu="activeTotalMenu"
                :key="$route.fullPath"
                v-model:isLoading="isLoading"
                :customDeskId="customDeskId"
                :activeTopMenu="activeTopMenu"
                :activeTopChildMenu="activeTopChildMenu">
              </component>
            </template>
          </router-view>
        </el-main>
      </el-container>
      <custom-loading :loading="isLoading"></custom-loading>
      <!-- 底部导航栏 -->
      <bottom-nav-bar
        v-if="isShowBottomNavBar"
        :bottomNavData="bottomNavData"
      ></bottom-nav-bar>
    </el-container>
  </div>
</template>

<script>
import headerZun from '@/components/common/headerHome.vue'
import bottomNavBar from '@/components/common/bottomNavBar.vue'
import { cloneDeep } from 'lodash'
import iconMixin from '@/components/common/icon/common.js'
import topLeftNav from './schoolInstrument/common/topLeftNav.vue';

export default {
  name: "schoolHome",
  data () {
    return {
      customDeskId: 0,
      isShowTopNavBar: true, //顶部导航显示隐藏
      isShowBottomNavBar: false, //底部版权信息显示隐藏
      bottomNavData: {
        topStyle: {}
      }, //底部版权信息相关数据
      headerHeight: '50px', //导航高度
      // 页面背景
      bodyBgInfo: {
        backgroundImage: '',
        backgroundColor: '',
        backgroundSize: ''
      },
      styleInfo: {},
      activeTotalMenu: 1,
      // 顶部导航栏画布活跃的id
      activeTopMenu: 1,
      // 顶部导航兰子集画布活跃的id
      activeTopChildMenu: 0,
      isLoading: false,
      isOpenLogin: false,
      curValue: {},
      loginStatus: 'keep',
      loginMethod: 4,
      isCollapse: false,
    };
  },
  components: {
    headerZun,
    bottomNavBar,
    topLeftNav,
  },
  mixins: [iconMixin],
  provide() { 
    return {
      homeId: () => { return this.customDeskId }
    }
  },
  created() {
    if (this.$route.path === '/index' || this.$route.path === '/space/index' || this.$route.path.includes('website')) {
      this.isLoading = true
    }
  },
  mounted() {
    if (this.$route.path === '/clientSide/oaExamine' || this.$route.path === '/space/oaExamine' || this.$route.path === '/upace/oaExamine') {
      this.activeTopMenu = 2
      this.activeTopChildMenu = 0
    } else if (this.$route.path === '/clientSide/workbench' || this.$route.path === '/space/workbench' || this.$route.path === '/upace/workbench') {
      this.activeTopMenu = 3
      this.activeTopChildMenu = 0
    }
    window.yzf && window.yzf.init({
      sign: '37ef9b97817606c0714098e749b7b065a7d45fc87dd41dced6798687f62c74f53d82015700544e893f639a6e58039bf47ddb2cc2',
      uid: '',
      data: {
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        c5: ''
      },
      selector: '',
      callback: function () {
        return false;
      }
    })
  },
  computed: {
    handlePosition () {
      if (this.styleInfo.slideEffect === 'seize') {
        return false
      } else {
        if (this.$refs.headerZun && this.$refs.headerZun.handleIsMenu) {
          return false
        } else {
          return this.styleInfo.slideEffect !== 'seize'
        }
      }
    },
    navFree () {
      return this.styleInfo.topAdsorption === 'free'
    },
    leftNavList () {
      if (!this.bottomNavData.topContentInfo) return []
      if (!this.bottomNavData.topContentInfo.list) return []
      if (!this.bottomNavData.topContentInfo.list.navbar) return []
      let li = this.bottomNavData.topContentInfo.list.navbar.list
      li = li.filter(f => {
        f.lists = f.lists.filter(c => c.isShow)
        return f.isShow
      })
      return li
    },
    isAppenLi() {
      const li = this.leftNavList
      if (!li) return false
      if (li.length === 1 && li.lists && li.lists.length !== 0) {
        return li[0].lists.length > 1
      }
      return li.length > 1
    },
  },
  watch: {
    '$route': {
      handler(to, from) {
        const query = from.query
        const querys = {}
        if (query.spaceid) querys.spaceid = query.spaceid
        if (query.upaceid) querys.upaceid = query.upaceid
        if (query.isNews) {
          localStorage.setItem('menuNav', JSON.stringify(this.curValue))
        }
      }
    }
  },
  methods: {
    async handleNavClick(val) {
      const headerZun = this.$refs.headerZun
      if (!headerZun) return
      const flag = await headerZun.setActiveNav(val)
      console.log(flag,'flagflagflag')
      if (flag) this.activeTotalMenu = val.id
      else this.$refs.topLeftNav.$refs.leftNav.activeIndex = this.activeTopMenu + ''
    },
    pageJump(val) {
      this.$refs.schoolMain.pageJump(val)
    },
    openTopNav(val) {
      const nav = this.$refs.headerZun
      if (!nav) {
        this.$message.error('请打开顶部导航栏')
        return
      }
      const layout = nav.layout
      const ref = `layout${layout}`
      const cnav = nav.$refs[ref]
      if (!cnav) return
      cnav.active(0, val)
    },
    getToken(val) {
      this.$store.commit('changeTemporaryToken', val)
      this.$refs.schoolMain.setOpenPage(val)
    },
    openLogin(val, loginMethod) {
      this.isOpenLogin = true
      this.loginStatus = val
      if (loginMethod !== undefined) {
        this.loginMethod = loginMethod
      }
    },
    handleMenuClick(value) {
      if (!value) return
      this.curValue = cloneDeep(value)
      delete this.curValue.layout
      if (this.$route.params.skey) {
        const query = this.$route.query
        const path = this.$route.path
        const querys = {}
        if (query.spaceid) querys.spaceid = query.spaceid
        if (query.upaceid) querys.upaceid = query.upaceid
        if (query.isNews) {
          localStorage.setItem('menuNav', JSON.stringify(this.curValue))
          this.$router.push({
            path,
            query: querys
          })
        }
      }
      this.activeTotalMenu = value.id
      const li = this.$refs.headerZun.checkObj.list || []
      const cnav = li.find(item => item.id === value.id)
      if (cnav) {
        this.activeTopChildMenu = 0
        this.activeTopMenu = value.id
      } else {
        li.forEach(item => {
          item.lists.forEach(item2 => {
            if (item2.id === value.id) {
              this.activeTopChildMenu = value.id
              this.activeTopMenu = item.id
            }
          })
        })
      }
    },
    // 获取导航区域高度
    headerInfo (val) {
      this.bottomNavData = val;
      if (val.topStyle.layout == 1) {
        // this.headerHeight = val.topContentInfo.h + 5 + 'px';
        this.headerHeight = val.topContentInfo.h + 'px';
      }
      else if (val.topStyle.layout == 2) {
        this.headerHeight = Number(val.topContentInfo.list.above.h + val.topContentInfo.list.below.h + val.topContentInfo.list.middle.h + val.topContentInfo.list.route.h) + 5 + 'px';
      }
      console.log(this.headerHeight);
    },
    getFooterData (val) {
      this.bottomNavData = val;
      this.isShowTopNavBar = val.overAllStyle.isShowTopNavBar;
      this.isShowBottomNavBar = val.overAllStyle.isShowBottomNavBar;
      if (Object.prototype.hasOwnProperty.call(this.bottomNavData.overAllStyle, 'backGroundInfo')) {
        switch (this.bottomNavData.overAllStyle.backGroundInfo.radio) {
          case "image":
            this.bodyBgInfo.backgroundImage = `url(${this.$url}${this.bottomNavData.overAllStyle.backGroundInfo.imageUrl})`
            this.bodyBgInfo.backgroundColor = '';
            if (this.bottomNavData.overAllStyle.bgPosition === 'cover') {
              this.bodyBgInfo.backgroundSize = '100%'
            }
            break;
          case "color":
            this.bodyBgInfo.backgroundImage = '';
            this.bodyBgInfo.backgroundColor = this.bottomNavData.overAllStyle.backGroundInfo.color;
            break;
          default:
            this.bodyBgInfo.backgroundImage = '';
            this.bodyBgInfo.backgroundColor = '';
            break;
        }
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.schoolHome {
  position: relative;
  box-sizing: border-box;
  overflow: auto;
  flex: 1;
  overflow-x: hidden;
}

.schoolHomeContainer {
  display: flex;
  height: 100vh;
}

.free-nav {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 22;
  transition: initial;
  width: 100%;
}
.schoolHome-main {
  display: flex;
  flex-direction: column;
}
.headerBg {
  background: transparent;
}
.fixed-top {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.pb100 {
  // padding-bottom: var(--pb);
}
.el-container {
  background-repeat: no-repeat;
  background-position: 50% 0;
}
.el-col {
  padding: 0 12px 0 0;
}
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
  height: 100%;
  // overflow: hidden;
  overflow: visible;
}
.userinfo {
  text-align: right;
  padding-right: 0;
  float: right;
}
.userinfo-inner {
  width: 100px;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  cursor: pointer;
}
.userinfo-inner .sysUserAvatar {
  width: 30px;
  height: 30px;
  border-radius: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  background: #ffffff;
  margin: 15px 10px 10px 10px;
  float: left;
}
.logo {
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
}
.logo img {
  height: 36px;
  vertical-align: middle;
}
.logo span {
  vertical-align: middle;
  font-size: 16px;
  padding-left: 8px;
}
.txt {
  color: #fff;
}
.tools {
  padding: 0px 23px;
  width: 14px;
  height: 40px;
  background: #f1f2f7;
  line-height: 60px;
  cursor: pointer;
}
.el-menu {
  height: 100%;
}
.header-search {
  font-size: 12px;
}
.router-link-active {
  color: #000;
}
.navUl {
  padding: 0;
}
.navUl li {
  float: left;
  text-align: center;
  cursor: pointer;
}
.el-icon-sty {
  padding-right: 6px;
}
.navUl li {
  font-size: 16px;
  padding: 0;
  width: 20%;
  height: 56px;
  /* border-top: 4px solid #19B359; */
  color: #000000;
}
</style>
